export const JOURNEY_GRACE_PERIOD_DAYS = 7;